import firestore from '@react-native-firebase/firestore';
import 'react-native-get-random-values';
import {v4 as uuidv4} from 'uuid';
import messaging from '@react-native-firebase/messaging';
// import { Alert } from 'react-native'; // Імпортуємо Alert для відображення сповіщень в додатку
import {
  BUTTON_STATUS_ENUM,
  CHAT_MESSAGE_TYPE_ENUM,
  CHAT_TYPE_ENUM,
  ChatType,
  ConciergeChatType,
  CONCIERGE_CHAT_TYPE_ENUM,
  ChatMessageType,
} from '../../types/chat';

import moment from 'moment';
import {useUserStore} from '~providers/userStore/zustand';
import {BASE_API_URL} from '@env';
import {Event} from '~types/api/event';
import i18n from 'i18next';
// import OneSignalService from '~services/FirebaseNotificationsService';
// import {Notifier, NotifierComponents} from 'react-native-notifier';

class FirebaseChats {
  deleteGroupChat(arg0: {event_id: number}) {
    throw new Error('Method not implemented.');
  }
  
  private _firestore: any = null;
  private _messaging: any = null;
  auth = useUserStore.getState().user;

  // Lazy-load firestore to avoid initialization issues on web
  get firestore() {
    if (!this._firestore) {
      this._firestore = firestore();
    }
    return this._firestore;
  }

  // Lazy-load messaging to avoid initialization issues on web
  get messaging() {
    if (!this._messaging) {
      this._messaging = messaging();
    }
    return this._messaging;
  }

  constructor() {
    // Lazy initialization - firestore and messaging are loaded on first access

    this.createNewGroupChat = this.createNewGroupChat.bind(this);
    this.createPrivateChat = this.createPrivateChat.bind(this);
    this.createPyxiConciergeChat = this.createPyxiConciergeChat.bind(this);
    this.removeUserFromTheGroupChat = this.removeUserFromTheGroupChat.bind(this);
    this.pushConciergeMessage = this.pushConciergeMessage.bind(this);
    this.pushMessageForUsers = this.pushMessageForUsers.bind(this);
    this.updateUserFcmToken = this.updateUserFcmToken.bind(this);
    this.createOrganisationChat = this.createOrganisationChat.bind(this);
    this.createContactUsChat = this.createContactUsChat.bind(this);
    // this.handleForegroundNotification = this.handleForegroundNotification.bind(this);
    // Викликаємо метод для обробки сповіщень на передньому плані
    // this.handleForegroundNotification();
  }

  async updateUserFcmToken(token: string) {
    try {
      const currentUser = useUserStore.getState().user;
      if (currentUser) {
        const userDocRef = this.firestore.collection('users').doc(currentUser.uid);
        await userDocRef.set(
          {
            deviceFcmToken: token,
          },
          {merge: true},
        );
      } else {
        console.log('No user is signed in.');
      }
    } catch (error) {
      console.error('Error updating FCM token in Firestore:', error);
    }
  }

  async sendPushNotification(token: string, title: string, message: string, data: object) {
    const serverKey =
      'AAAA3g8xYT0:APA91bEs7-It_xwurSWKqQ0pCUQIhR19CS0nEEIpv3j04zKczi6MTuwE7Ed4NAN28EyliGWppc3KFiymdM1fTSpKMQF_kBSjGb6patTJqkC_1Z3cbRTM42mm_9egAiO87hexW683ONVT';
    try {
      const response = await fetch('https://fcm.googleapis.com/fcm/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `key=${serverKey}`,
        },
        body: JSON.stringify({
          to: token,
          notification: {
            title: title,
            body: message,
          },
          data: {
            ...data,
          },
        }),
      });

      const responseData = await response.json();
      console.log('FCM response:', responseData);
    } catch (error) {
      console.error('Error sending FCM message:', error);
    }
  }

  // async handleForegroundNotification() {
  //   messaging.onMessage(async remoteMessage => {
  //     console.log('A new FCM message arrived!', JSON.stringify(remoteMessage));
  //     // Відображаємо сповіщення в додатку за допомогою Alert
  //     Notifier.showNotification({
  //       title: remoteMessage?.notification?.title,
  //       description: remoteMessage?.notification?.body,
  //       Component: NotifierComponents.Alert,
  //       componentProps: {
  //         alertType: 'info',
  //       },
  //     });
  //   });
  // }

  async createNewGroupChat({
    event_id,
    event_image,
    event_name,
    user_name,
    user_id,
    otherUsersId,
    otherUsersName,
  }: {
    event_id: number;
    event_image: string;
    event_name: string;
    user_name: string;
    user_id: string;
    otherUsersId: string[];
    otherUsersName: string[];
  }): Promise<string | undefined> {
    try {
      const existingChat = await this.firestore.collection('chats').where('eventId', '==', event_id).get();
      if (existingChat.docs[0]?.id) {
        return existingChat.docs[0].id;
      }

      await this.firestore.collection('chats').add({
        type: CHAT_TYPE_ENUM.GROUP,
        userIds: [user_id, ...otherUsersId],
        users: [user_name, ...otherUsersName],
        history: [
          {
            message_id: uuidv4(),
            message: `Welcome to ${event_name}!`,
            type: CHAT_MESSAGE_TYPE_ENUM.INFO,
            sender_image: event_image,
            sender_id: '',
            sender: '',
            readUserIds: [],
            timestamp: moment().toISOString() as unknown,
          },
        ],
        eventImage: event_image,
        eventName: event_name,
        eventId: event_id,
      } as ChatType);

      const querySnapshot = await this.firestore.collection('chats').where('eventId', '==', event_id).get();
      if (querySnapshot.docs[0]?.id) {
        return querySnapshot.docs[0].id;
      }
    } catch (e) {
      console.error(e);
    }
    return undefined; // Додано повернення undefined у випадку помилки або відсутності значення
  }

  async addNewUserToTheGroupChat({
    user_id,
    event_id,
    user_name,
    user_image,
  }: {
    user_id: string;
    event_id: number;
    user_name: string;
    user_image: string;
  }) {
    try {
      const querySnapshot = await this.firestore.collection('chats').where('eventId', '==', event_id).get();

      querySnapshot.forEach(async snap => {
        const currentChat = snap.data() as ChatType;

        await snap.ref.update({
          history: [
            ...currentChat.history,
            {
              message_id: uuidv4(),
              message: `${user_name} has joined the event`,
              type: CHAT_MESSAGE_TYPE_ENUM.INFO,
              sender_image: user_image,
              sender_id: '',
              sender: user_name,
              readUserIds: [],
              timestamp: moment().toISOString() as unknown,
            },
          ],
          users: [...currentChat.users, user_name],
          userIds: [...currentChat.userIds, user_id],
        });
      });
    } catch (_) {}
  }

  async createContactUsChat({
    user_id1,
    user_id2,
    user_name1,
    user_name2,
  }: {
    user_id1: string;
    user_id2: string;
    user_name1: string;
    user_name2: string;
  }) {
    try {
      console.log("🔍 createContactUsChat: Starting with params:", {
        user_id1,
        user_id2,
        user_name1,
        user_name2
      });

      // Validate required parameters
      if (!user_id1) {
        throw new Error('user_id1 is required but was: ' + user_id1);
      }
      if (!user_id2) {
        throw new Error('user_id2 is required but was: ' + user_id2);
      }
      if (!user_name1 || user_name1.trim() === '') {
        throw new Error('user_name1 is required but was: "' + user_name1 + '"');
      }
      if (!user_name2 || user_name2.trim() === '') {
        throw new Error('user_name2 is required but was: "' + user_name2 + '"');
      }

      const existingChat = await this.firestore.collection('chats').where('userIds', 'array-contains', user_id1).get();

      const existChatSnap = existingChat.docs.find(doc => {
        const chat = doc.data() as ChatType;
        return chat.type === 'contact-pyxi-select' && chat.userIds.includes(user_id2);
      });

      console.log("existChatSnap", existChatSnap);
      

      if (existChatSnap) {
        console.log("🔍 Found existing chat:", existChatSnap.id);
        return existChatSnap.id;
      } else {
        // Try with string literal instead of enum to debug
        const newChatData = {
          type: 'contact-pyxi-select',
          userIds: [user_id1, user_id2],
          users: [user_name1.trim(), user_name2.trim()],
          progress: 'new',
          history: [],
          status: 'open',
        };

        console.log("🔍 Creating new chat with data:", JSON.stringify(newChatData, null, 2));

        const newChat = await this.firestore.collection('chats').add(newChatData);
        console.log("✅ newChat created successfully:", newChat.id);
        return newChat.id;
      }
    } catch (error) {
      console.error("❌ Error in createContactUsChat:", error);
      return '';
    }
  }

  async createPrivateChat({
    user_id1,
    user_id2,
    user_name1,
    user_name2,
    user_image,
    event,
  }: {
    user_id1: string;
    user_id2: string;
    user_name1: string;
    user_name2: string;
    user_image: string;
    event?: Event;
  }) {
    console.log('� [FIRESTORE] FirebaseChats.createPrivateChat - START');
    try {
      console.log('🔥 [FIRESTORE] FirebaseChats.createPrivateChat - Input params:', {
        user_id1,
        user_id2,
        user_name1,
        user_name2,
        user_image,
        event: event ? 'event provided' : 'no event',
      });

      // Validate required parameters
      if (!user_id1) {
        throw new Error('user_id1 is required but was: ' + user_id1);
      }
      if (!user_id2) {
        throw new Error('user_id2 is required but was: ' + user_id2);
      }
      if (!user_name1 || user_name1.trim() === '') {
        throw new Error('user_name1 is required but was: "' + user_name1 + '"');
      }
      if (!user_name2 || user_name2.trim() === '') {
        throw new Error('user_name2 is required but was: "' + user_name2 + '"');
      }
      if (!user_image) {
        throw new Error('user_image is required but was: ' + user_image);
      }

      // Clean up the names to remove extra whitespace
      const cleanUser1Name = user_name1.trim();
      const cleanUser2Name = user_name2.trim();
      
      console.log('🔥 [FIRESTORE] createPrivateChat - Querying existing chats...');
      const existingChat = await this.firestore.collection('chats').where('userIds', 'array-contains', user_id1).get();
      console.log('🔥 [FIRESTORE] createPrivateChat - Query result:', {
        resultCount: existingChat.docs.length,
        docs: existingChat.docs.map(d => ({ id: d.id, data: d.data() }))
      });

      const existChatSnap = existingChat.docs.find(doc => {
        const chat = doc.data() as ChatType;
        return chat.type === CHAT_TYPE_ENUM.PRIVATE && chat.userIds.includes(user_id2);
      });

      if (existChatSnap) {
        console.log('🔥 [FIRESTORE] createPrivateChat - Found existing private chat:', existChatSnap.id);
        const chatRef = this.firestore.collection('chats').doc(existChatSnap.id);

        // Only add event message if event is provided
        if (event) {
          console.log('🔥 [FIRESTORE] createPrivateChat - Fetching chat data to add event message...');
          const dataRef = (await chatRef.get()).data()! as ChatType;
          console.log('🔥 [FIRESTORE] createPrivateChat - Chat data retrieved:', { 
            historyLength: dataRef.history.length,
            chat: dataRef 
          });

          const updated = [
            ...dataRef.history,
            {
              message_id: uuidv4(),
              message: '',
              type: CHAT_MESSAGE_TYPE_ENUM.EVENT,
              sender_image: user_image,
              sender_id: user_id1,
              sender: cleanUser1Name,
              readUserIds: [],
              timestamp: moment().toISOString(),
              event: event,
            },
          ];

          console.log('🔥 [FIRESTORE] createPrivateChat - Updating chat with new history...');
          await chatRef.update({
            history: updated,
          });
          console.log('🔥 [FIRESTORE] createPrivateChat - Chat updated successfully');
        }

        console.log('🔥 [FIRESTORE] createPrivateChat - Returning existing chat ID:', existChatSnap.id);
        return existChatSnap.id;
      } else {
        console.log('🔥 [FIRESTORE] createPrivateChat - No existing chat found, creating new one...');
        const history: ChatMessageType[] = [];
        if (event) {
          history.push({
            message_id: uuidv4(),
            message: '',
            type: CHAT_MESSAGE_TYPE_ENUM.EVENT,
            sender_image: user_image,
            sender_id: user_id1,
            sender: cleanUser1Name,
            readUserIds: [],
            timestamp: moment().toISOString(),
            event: event,
          });
        }
        const newChatData: ChatType = {
          type: CHAT_TYPE_ENUM.PRIVATE,
          userIds: [user_id1, user_id2],
          users: [cleanUser1Name, cleanUser2Name],
          status: 'open',
          progress: 'new',
          history: history,
          ...(event && {event}),
        };

        console.log('🔥 [FIRESTORE] createPrivateChat - Creating new chat with data:', newChatData);
        const newChat = await this.firestore.collection('chats').add(newChatData);
        console.log('🔥 [FIRESTORE] createPrivateChat - New chat created with ID:', newChat.id);
        return newChat.id;
      }
    } catch (error) {
      console.error('❌ [FIRESTORE] createPrivateChat CRITICAL ERROR:', error);
      console.error('❌ [FIRESTORE] Error details:', JSON.stringify(error, null, 2));
      throw error; // Don't return empty string, let the error bubble up
    }
  }

  async createOrganisationChat({
    user_id1,
    user_id2,
    user_name1,
    user_name2,
    user_image,
    user_image2,
    isTechnical,
    event,
    isPyxiSelect,
  }: {
    user_id1: string;
    user_id2: string;
    user_name1: string;
    user_name2: string;
    user_image: string;
    user_image2: string;
    isTechnical?: boolean;
    event: Event | null | undefined;
    isPyxiSelect?: boolean;
  }) {

    // Extract first name only from user_name1
    const firstName = user_name1.split(' ')[0];

    // Replace specific user_id2 if it matches the old value
      if (user_id2 === 'bxcOenW6joNFwgiMBctR0zJT07F2') {
        user_id2 = 'CmCCvWvpRVhhFlHdgU9QE6hbun82';
        console.log("🔄 Replaced user_id2 with new value:", user_id2);
      }

    try {
      const existingChat = await this.firestore.collection('chats').where('userIds', 'array-contains', user_id1).get();
      const chatsSnapshot = await this.firestore.collection('chats').get();
      const totalChats = chatsSnapshot.size;

      const existChatSnap = existingChat.docs.find(doc => {
        const chat = doc.data() as ChatType;
        return chat.type === CHAT_TYPE_ENUM.ORGANISATION && chat.userIds.includes(user_id2);
      });

      if (existChatSnap) {
        const chatRef = this.firestore.collection('chats').doc(existChatSnap.id);
        const updateData: any = {status: 'open'};
        if (event) {
          updateData.event = event;
        }
        chatRef.update(updateData);
        if (event) {
          const dataRef = (await chatRef.get()).data()! as ChatType;
          const messageHistory = [
            {
              message_id: uuidv4(),
              message: '',
              type: CHAT_MESSAGE_TYPE_ENUM.EVENT,
              sender_image: user_image,
              sender_id: user_id1,
              sender: user_name1,
              readUserIds: [],
              timestamp: moment().toISOString(),
              event: event,
            },
            {
              message_id: uuidv4(),
              message: isTechnical
                ? i18n.t('technical_issue', {name: 'Pyxi'})
                : i18n.t('greeting', {user_name1: user_name2}),
              type: CHAT_MESSAGE_TYPE_ENUM.MESSAGE,
              sender_image: user_image,
              sender_id: user_id1,
              sender: user_name1,
              readUserIds: [],
              timestamp: moment().toISOString(),
            },
          ];
          if (isPyxiSelect || isTechnical) {
            messageHistory.push({
              message_id: uuidv4(),
              message: isTechnical
                ? `Hi ${firstName}, I'm sorry to hear that! What's the issue exactly?`
                : `Hi ${firstName}, thanks for contacting us. what kind of issue are you facing?`,
              type: CHAT_MESSAGE_TYPE_ENUM.MESSAGE,
              sender_image: user_image2,
              sender_id: user_id2,
              sender: user_name2,
              readUserIds: [],
              timestamp: moment().toISOString(),
            });
          }
          console.log(messageHistory, 'messageHistorymessageHistory');

          const updated = [...dataRef.history, ...messageHistory];

          await chatRef.update({
            history: updated,
          });
        }
        return existChatSnap.id;
      } else {
        if (isTechnical) {
          const newChatData: ChatType = {
            type: CHAT_TYPE_ENUM.ORGANISATION,
            userIds: [user_id1, user_id2],
            users: [user_name1, user_name2],
            status: 'open',
            progress: 'new',
            ...(event && {event}),
            issueNumber: [totalChats],
            history: [
              {
                message_id: uuidv4(),
                message: i18n.t('technical_issue', {name: 'Pyxi'}),
                type: CHAT_MESSAGE_TYPE_ENUM.MESSAGE,
                sender_image: user_image,
                sender_id: user_id1,
                sender: user_name1,
                readUserIds: [],
                timestamp: moment().toISOString(),
              },
              {
                message_id: uuidv4(),
                message: `Hi ${firstName}, I'm sorry to hear that! What's the issue exactly?`,
                type: CHAT_MESSAGE_TYPE_ENUM.MESSAGE,
                sender_image: user_image2,
                sender_id: user_id2,
                sender: user_name2,
                readUserIds: [],
                timestamp: moment().toISOString(),
              },
            ],
          };

          const newChat = await this.firestore.collection('chats').add(newChatData);
          return newChat.id;
        } else {
          const messageHistory = [];
          if (event) {
            messageHistory.push({
              message_id: uuidv4(),
              message: '',
              type: CHAT_MESSAGE_TYPE_ENUM.EVENT,
              sender_image: user_image,
              sender_id: user_id1,
              sender: user_name1,
              readUserIds: [],
              timestamp: moment().toISOString(),
              event: event,
            });
          }
          messageHistory.push({
            message_id: uuidv4(),
            message: i18n.t('greeting', {user_name1: user_name2}),
            type: CHAT_MESSAGE_TYPE_ENUM.MESSAGE,
            sender_image: user_image,
            sender_id: user_id1,
            sender: user_name1,
            readUserIds: [],
            timestamp: moment().toISOString(),
          });
          if (isPyxiSelect || isTechnical) {
            messageHistory.push({
              message_id: uuidv4(),
              message: isTechnical
                ? `Hi ${firstName}, I'm sorry to hear that! What's the issue exactly?`
                : `Hi ${firstName}, thanks for contacting us. what kind of issue are you facing?`,
              type: CHAT_MESSAGE_TYPE_ENUM.MESSAGE,
              sender_image: user_image2,
              sender_id: user_id2,
              sender: user_name2,
              readUserIds: [],
              timestamp: moment().toISOString(),
            });
          }
          const newChatData: ChatType = {
            type: CHAT_TYPE_ENUM.ORGANISATION,
            userIds: [user_id1, user_id2],
            users: [user_name1, user_name2],
            status: 'open',
            progress: 'new',
            ...(event && {event}),
            issueNumber: [totalChats],
            history: messageHistory,
          };

          const newChat = await this.firestore.collection('chats').add(newChatData);
          return newChat.id;
        }
      }
    } catch (_) {
      return '';
    }
  }

  async createPyxiConciergeChat({
    user_id,
    user_name,
    user_image,
  }: {
    user_id: string;
    user_name: string;
    user_image: string;
  }) {
    const conciergeChatExists = await this.firestore.collection('conciergeChat').where('userId', '==', user_id).get();

    conciergeChatExists.empty &&
      (await this.firestore.collection('conciergeChat').add({
        type: CONCIERGE_CHAT_TYPE_ENUM.ONE_ON_ONE,
        userId: user_id,
        userName: user_name,
        userImage: user_image,
        messages: [
          {
            timestamp: moment().toISOString() as unknown,
            senderId: user_id,
            sender: user_name,
            status: BUTTON_STATUS_ENUM.EMPTY,
            readUserIds: [],
            message: 'Welcome to Pyxi, your personal assistant for all things social. How may I help you today?',
          },
        ],
      } as ConciergeChatType));
  }

  async removeUserFromTheGroupChat({
    user_id,
    event_id,
    user_name,
    event_image,
  }: {
    user_id: string;
    event_id: number;
    user_name: string;
    event_image: string;
  }) {
    const querySnapshot = await this.firestore.collection('chats').where('eventId', '==', event_id).get();

    if (querySnapshot.empty) {
      return;
    }
    querySnapshot.forEach(async snap => {
      const currentChat = snap.data() as ChatType;
      await snap.ref.update({
        userIds: [...currentChat.userIds.filter(userId => userId !== user_id)],
        history: [
          ...currentChat.history,
          {
            message_id: uuidv4(),
            message: `${user_name} has exited the chat`,
            type: CHAT_MESSAGE_TYPE_ENUM.INFO,
            sender_image: event_image,
            sender_id: '',
            sender: user_name,
            readUserIds: [...currentChat.userIds.filter(userId => userId !== user_id)],
            timestamp: moment().toISOString() as unknown,
          },
        ],
      });
    });
  }

  async callEmailNotificationApi(message_id: string, chat_id: string) {
    try {
      const token = useUserStore.getState().token;
      const url = `${BASE_API_URL}/firestore/chats/unread-users/${chat_id}/${message_id}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      const responseData = await response.json();
      console.log('callEmailNotificationApi', responseData);
    } catch (error) {
      console.log('callEmailNotificationApi', error);
    }
  }

  async pushMessageForUsers({
    chat_id,
    user_id,
    user_name,
    text,
    user_image,
    temp_message_id,
  }: {
    chat_id: string;
    user_id: string;
    user_image: string;
    user_name: string;
    text: string;
    temp_message_id?: string;
  }): Promise<string> {
    try {
      console.log('FirebaseChats: pushMessageForUsers called with:', {chat_id, user_id, user_name, text});

      if (!chat_id) {
        throw new Error('chat_id is required');
      }
      if (!user_id) {
        throw new Error('user_id is required');
      }
      if (!text) {
        throw new Error('text is required');
      }

      const datetime = moment().toISOString();
      const chatRef = this.firestore.collection('chats').doc(chat_id);

      console.log('FirebaseChats: Getting chat document...');
      const chatDoc = await chatRef.get();

      if (!chatDoc.exists) {
        throw new Error(`Chat document with id ${chat_id} does not exist`);
      }

      const dataRef = chatDoc.data() as ChatType;
      console.log('FirebaseChats: Current chat data:', dataRef);

      // Check if user is blocked before sending message
      const blockedUsers = dataRef.blockedUsers || {};
      const blockedBy = dataRef.blockedBy || {};

      // Check if current user has blocked someone in this chat
      const hasBlockedSomeone = Object.values(blockedUsers).includes(true);

      // Check if current user is blocked by someone in this chat
      const isBlockedByOtherUser = Object.keys(blockedBy).includes(user_id);

      if (hasBlockedSomeone || isBlockedByOtherUser) {
        throw new Error('Message cannot be sent due to user blocking');
      }

      const message_id = temp_message_id || uuidv4();
      const newMessage = {
        message_id: message_id,
        message: text,
        sender: user_name,
        sender_image: user_image,
        sender_id: user_id,
        timestamp: datetime,
        type: CHAT_MESSAGE_TYPE_ENUM.MESSAGE,
        readUserIds: [user_id],
        status: 'sent',
      };

      const updated = [...(dataRef.history || []), newMessage];

      console.log('FirebaseChats: Updating chat with new message...');
      await chatRef.update({
        history: updated,
      });

      console.log('FirebaseChats: Message sent successfully');
      this.callEmailNotificationApi(message_id, chat_id);

      const userUidsArr = [...(dataRef.userIds || []).filter(id => id !== user_id)];

      if (userUidsArr.length > 0) {
        const requestNotificationBody = {
          headings: {
            en: user_name,
          },
          contents: {
            en: text,
          },
          data: {
            chat_id: chat_id,
            type: 'ChatNotification',
            chat_type: dataRef.type,
            clickAction: 'OPEN_CHAT',
          },
          include_external_user_ids: userUidsArr,
        };

        const token = useUserStore.getState().token;
        const url = `${BASE_API_URL}/send-notification`;
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
          body: JSON.stringify(requestNotificationBody),
        });

        const responseData = await response.json();
        console.log('new Message', responseData);
      }

      return message_id;
    } catch (error) {
      console.error('FirebaseChats: pushMessageForUsers error:', error);
      throw error; // Re-throw the error so it can be caught by the calling function
    }
  }
  async markMessageAsRead({
    chat_id,
    message_id,
    user_id,
    chat_type = 'user',
  }: {
    chat_id: string;
    message_id: string;
    user_id: string;
    chat_type?: 'user' | 'concierge';
  }) {
    try {
      console.log('FirebaseChats: markMessageAsRead called with:', {chat_id, message_id, user_id, chat_type});

      const collection = chat_type === 'concierge' ? 'conciergeChat' : 'chats';
      const chatRef = this.firestore.collection(collection).doc(chat_id);
      const chatDoc = await chatRef.get();

      if (!chatDoc.exists) {
        throw new Error(`Chat document with id ${chat_id} does not exist`);
      }

      const chatData = chatDoc.data();
      const messages = chat_type === 'concierge' ? chatData?.messages : chatData?.history;

      if (!messages) {
        console.log('No messages found in chat');
        return;
      }

      // Find and update the specific message
      const updatedMessages = messages.map((msg: any) => {
        const msgId = chat_type === 'concierge' ? msg.messageId : msg.message_id;
        if (msgId === message_id) {
          return {
            ...msg,
            status: 'read',
            messageStatus: 'read',
            readUserIds: [...(msg.readUserIds || []), user_id].filter((id, index, arr) => arr.indexOf(id) === index),
          };
        }
        return msg;
      });

      const updateField = chat_type === 'concierge' ? 'messages' : 'history';
      await chatRef.update({
        [updateField]: updatedMessages,
      });

      console.log('FirebaseChats: Message marked as read successfully');
    } catch (error) {
      console.error('FirebaseChats: markMessageAsRead error:', error);
      throw error;
    }
  }

  async pushConciergeMessage({
    chat_id,
    user_id,
    user_name,
    text,
    temp_message_id,
  }: {
    chat_id: string;
    user_id: string;
    user_name: string;
    text: string;
    temp_message_id?: string;
  }): Promise<string> {
    try {
      console.log('FirebaseChats: pushConciergeMessage called with:', {
        chat_id,
        user_id,
        user_name,
        text,
        temp_message_id,
      });

      if (!chat_id) {
        throw new Error('chat_id is required');
      }
      if (!user_id) {
        throw new Error('user_id is required');
      }
      if (!text) {
        throw new Error('text is required');
      }

      const datetime = moment().toISOString();
      const messageId = temp_message_id || `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const chatRef = this.firestore.collection('conciergeChat').doc(chat_id);

      console.log('FirebaseChats: Getting chat document...');
      const chatDoc = await chatRef.get();

      if (!chatDoc.exists) {
        throw new Error(`Chat document with id ${chat_id} does not exist`);
      }

      const dataRef = chatDoc.data();
      console.log('FirebaseChats: Current chat data:', dataRef);

      const newMessage = {
        messageId,
        senderId: user_id,
        message: text,
        sender: user_name,
        timestamp: datetime,
        readUserIds: [user_id],
        messageStatus: 'sent',
      };

      const updated = [...(dataRef?.messages || []), newMessage];

      console.log('FirebaseChats: Updating chat with new message...');
      await chatRef.update({
        messages: updated,
      });

      console.log('FirebaseChats: Message sent successfully');

      // let data = {
      //   uid: user_id,
      //   title: user_name,
      //   message: text,
      //   additional_data: {
      //     chat_id: chat_id,
      //     type: 'AdminChat',
      //   },
      // };
      try {
        // await OneSignalService.sendPushNotification(data);
      } catch (error) {
        console.log('FirebaseChats: Push notification error:', error);
      }
      return messageId;
    } catch (error) {
      console.error('FirebaseChats: pushConciergeMessage error:', error);
      throw error; // Re-throw the error so it can be caught by the calling function
    }
  }
}

const FirebaseChatsService = new FirebaseChats();

export default FirebaseChatsService;
